import React from 'react';
import { useNavigate } from 'react-router-dom';
import RecipeForm from '../components/RecipeForm';

const CreateRecipePage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <RecipeForm
      onSuccess={() => navigate('/app/profile')}
      // `isEditing` defaults to false, `initialData` defaults to null
    />
  );
};

export default CreateRecipePage;
